export default "__VITE_ASSET__D$mEPpPd__"